import(/* webpackMode: "eager", webpackExports: ["PromptsPage"] */ "/home/runner/work/Planner/Planner/src/components/prompts/PromptsPage.tsx");
